export default "__VITE_ASSET__os_GOvxv__"